import React from "react";
import ReactDom from "react-dom";
import { useNavigate } from "react-router-dom";

const ModalMissionChecklist = ({ setOpenMission }) => {
  const navigate = useNavigate();

  const handleAccMission = (e) => {
    e.preventDefault();
    localStorage.setItem(
      "mission",
      JSON.stringify({ create_card: false, share_card: false }),
    );
    setOpenMission(false);
  };

  const handleSkipMission = (e) => {
    e.preventDefault();
    let user = JSON.parse(localStorage.getItem("user_info"));
    user.is_first_login = false;
    localStorage.setItem("user_info", JSON.stringify(user));
    setOpenMission(false);
  };

  return ReactDom.createPortal(
    <div className="flex flex-col fixed h-[100vh] w-[100vw] bg-opacity-30 bg-gray-400 top-0 left-0 z-[999999] backdrop-blur-sm justify-center items-center">
      <div className="flex flex-col bg-white border border-gray-200 p-5 max-w-[90%] md:w-1/6 gap-5">
        <div className="flex flex-row justify-between">
          <div className="text-lg font-semibold">
            Nice to meet you! Welcome to Nitomeyo
          </div>
        </div>

        <div>
          Let’s take a quick tour and finish the mission to get a surprise gift
        </div>
        <div className="flex flex-col w-full justify-end items-center gap-5">
          <div
            className="flex flex-col py-2 px-4 bg-primary text-white hover:bg-secondary cursor-pointer rounded-lg w-full text-center"
            onClick={handleAccMission}
          >
            Accept the mission
          </div>
          <div
            className="flex flex-col py-2 px-4 bg-white text-primary hover:text-white hover:bg-red-400 cursor-pointer rounded-lg w-full text-center border border-primary"
            onClick={handleSkipMission}
          >
            Skip
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default ModalMissionChecklist;
